export const isValidConsentEmail = (email) => typeof email === 'string' && /\S+@\S+\.\S+/.test(email);

export function getElectronicConsentError(form, showElectronicConsentDocument, isMultipleClaimFor) {
  if (showElectronicConsentDocument !== true) {
    return null;
  }
  if (form.electronicConsentDocument !== 'true' && form.electronicConsentDocument !== 'false') {
    return 'electronicConsentRequired';
  }
  if (form.electronicConsentDocument === 'true' && !isMultipleClaimFor && !isValidConsentEmail(form.emailAddress)) {
    return 'electronicConsentEmailInvalid';
  }
  return null;
}


// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/validation.js